import { observer } from 'mobx-react';
import { ORDER_HELP_FLOW_STEPS } from '@nandosaus/constants';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';

import { AddNote } from './components/add-note';
import { Confirmation } from './components/confirmation';
import { SelectIssue } from './components/select-issue';
import { SelectOrder } from './components/select-order';
import { SelectOrderItemIssue } from './components/select-order-item-issue';
import { SelectOrderItems } from './components/select-order-items';
import { SelectRefundType } from './components/select-refund-type';

const OrderHelp = observer(({ exitOrderHelp }) => {
  const { OrderHelpStore } = useRootStore();

  switch (OrderHelpStore.currentStep) {
    case ORDER_HELP_FLOW_STEPS.SELECT_ISSUE:
      return <SelectIssue />;
    case ORDER_HELP_FLOW_STEPS.SELECT_ORDER:
      return <SelectOrder />;
    case ORDER_HELP_FLOW_STEPS.SELECT_ORDER_ITEM:
      return <SelectOrderItems />;
    case ORDER_HELP_FLOW_STEPS.SELECT_ORDER_ITEM_ISSUE:
      return <SelectOrderItemIssue />;
    case ORDER_HELP_FLOW_STEPS.ADD_NOTES:
      return <AddNote />;
    case ORDER_HELP_FLOW_STEPS.SELECT_REFUND_TYPE:
      return <SelectRefundType />;
    case ORDER_HELP_FLOW_STEPS.CONFIRMATION:
      return <Confirmation goBack={() => exitOrderHelp()} />;
    default:
      return null;
  }
});

OrderHelp.propTypes = {
  exitOrderHelp: PropTypes.func.isRequired,
};
export { OrderHelp };
